var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 12.2254 19.1923 14.2621 17.8541 15.833L21.732 19.7114C22.1873 20.1668 22.1256 20.9669 21.594 21.4984C21.0625 22.0299 20.2624 22.0915 19.8071 21.6362L15.7914 17.6199C14.404 18.4942 12.7611 19 11 19C6.02944 19 2 14.9706 2 10C2 5.02944 6.02944 1 11 1C15.9706 1 20 5.02944 20 10ZM11 17C14.866 17 18 13.866 18 10C18 6.13401 14.866 3 11 3C7.13401 3 4 6.13401 4 10C4 13.866 7.13401 17 11 17ZM8 9C7.44772 9 7 9.44771 7 10C7 10.5523 7.44772 11 8 11H14C14.5523 11 15 10.5523 15 10C15 9.44771 14.5523 9 14 9H8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/ZoomOut.1b932e10a34b79c2d74412f785a90e37.svg";
export { ForwardRef as ReactComponent };